// Video source per device

$(document).ready(function(){

  $('[data-modal-target]').on('click', function(e){
    e.preventDefault();
    var link = $(this),
        modalId = link.data('modal-target');
    if (link.data('modal-target') == '#tv-modal-video'){
        videoByDevice();
        videoSwitch();
        var video = $('.tv-aboutVideo-video video');

        if(video.length){
          if($(window).width() >= 1024){
            video[0].src = video[0].dataset.videoDesktop;
          }
          else if($(window).width() >= 768){
            video[0].src = video[0].dataset.videoTablet;
          }

          video[0].muted = true;
          video[0].load();
          video[0].onloadeddata = function(){
            video[0].play();
          }
        }

        var vSwitch    = $('.tv-js-aboutVideo-videoSwitch');
        var vSoundSwitchOn = $('.tv-js-aboutVideo-videoSoundSwitch--on');
        var vSoundSwitchMute = $('.tv-js-aboutVideo-videoSoundSwitch--mute');
        var video      = $('.tv-aboutVideo-video video');
        var getsPaused = $('.tv-about-video');
        var videoState = 1;

        vSwitch.on('click', function(){
          if(videoState == 1){
                video.get(0).pause();
            videoState = 0;
            getsPaused.addClass('tv-aboutVideo--paused');
          }else{
            video.get(0).play();
            videoState = 1;
            getsPaused.removeClass('tv-aboutVideo--paused');
          }
        });

        vSoundSwitchOn.on('click', function(){
          vSoundSwitchOn.hide();
          vSoundSwitchMute.show();
          video.get(0).muted = false;
        });

        vSoundSwitchMute.on('click', function(){
          vSoundSwitchOn.show();
          vSoundSwitchMute.hide();
          video.get(0).muted = true;
        });
    }

    $(modalId).fadeIn(500);
  });

  $('.tv-modal').on('click', function(){
    $(this).fadeOut();
  });

});